import React, {useEffect, useState} from "react"
import HorizontalBanner, {HorizontalBannerPositions} from "@irati-web/platform/src/components/HorizontalBanner"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {withTheme, WithDefaultTheme} from "styled-components"
import {WalletTopupServiceCharge} from "@irati/types"
import topupService from "@irati/wallet/services/TopUp"
import Flex from "@irati/ui/src/Flex"

const RewardsOfferTopBanner: React.FC<WithDefaultTheme> = ({theme}) => {
  const [serviceCharge, setServiceCharge] = useState<WalletTopupServiceCharge>({base: 0, forNextTransfer: 0})

  useEffect(() => {
    topupService.serviceCharge().then(setServiceCharge)
  }, [])

  if (serviceCharge.forNextTransfer !== 0) {
    return null
  }
  return (
    <HorizontalBanner position={HorizontalBannerPositions.ABSOLUTE}>
      <Flex justifyContent="center" alignItems="center" margin="auto" gap="1rem" wrap="wrap">
        <Body small color="white" marginBottom={0}>
          <Body display="inline" textAlign="center" weight="bold" color={theme.colors.tertiary.g_400}>
            <FormattedMessage id="wallet.reward.admin.topup.timeOffer" />
          </Body>
          <Body display="inline" weight="bold" marginLeft={1} color="white">
            <FormattedMessage id="wallet.reward.admin.topup.serviceFeeOffer" />
          </Body>
        </Body>
        <ButtonRouterLink to="/flexi-checkout/top-up" inverted small>
          <FormattedMessage id="platform.serviceFeeBanner.buyPoints" />
        </ButtonRouterLink>
      </Flex>
    </HorizontalBanner>
  )
}

export default withTheme(RewardsOfferTopBanner)
